import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export default function WorkItems({ kind, items, parents, context, refresh, isCompleted, onBusyChange }) {
  const isIssue = kind === 'issue';
  const noun = isIssue ? 'Issue' : 'Task';
  const parentField = isIssue ? 'parent_goal_id' : 'parent_issue_id';
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState('');
  const [parentId, setParentId] = useState('');
  const [busy, setBusy] = useState(false);
  const mutate = async (path, body, success) => {
    if (busy || isCompleted) return;
    setBusy(true); onBusyChange(true);
    try {
      await axios.post(`${process.env.REACT_APP_WEB_URL}api/${path}`, { ...context, ...body }, { withCredentials: true });
      await refresh();
      if (success) success();
    } catch (error) { toast.error(error.response?.data?.message || `Unable to save this ${kind}. Please try again.`); }
    finally { setBusy(false); onBusyChange(false); }
  };
  const add = event => {
    event.preventDefault();
    mutate(`${kind}/add-${kind}`, { name, [parentField]: parentId }, () => { setAdding(false); setName(''); setParentId(''); });
  };
  return <div>
    <h2>{isIssue ? 'Issues' : 'Tasks'}</h2>
    <p>{isIssue ? 'Raise blockers and resolve issues against your roundup goals.' : 'Add actions and mark the work you have finished this week.'}</p>
    <div className="roundup-table-scroll"><table><thead><tr><th>{noun}</th><th>Status</th><th>{isIssue ? 'Parent Goal' : 'Parent Issue'}</th><th></th></tr></thead><tbody>
      {items.length ? items.map(item => <tr key={item._id}>
        <td>{item.name}</td><td><span className={`goal-progress status-${item.status === 'completed' ? 'completed' : 'in-progress'}`}>{item.status === 'completed' ? 'Complete' : 'Pending'}</span></td>
        <td>{item[parentField]?.name || 'Parent no longer available'}</td>
        <td>{!isCompleted && item.status !== 'completed' && <button disabled={busy} onClick={() => mutate(`roundups/underway/complete-${kind}`, { _id: item._id })}>Complete</button>}</td>
      </tr>) : <tr><td colSpan="4">No {isIssue ? 'issues' : 'tasks'} for this roundup.</td></tr>}
    </tbody></table></div>
    {!isCompleted && <button disabled={busy || !parents.length} onClick={() => setAdding(true)}>{isIssue ? 'Raise Issue' : 'Add Task'}</button>}
    {!isCompleted && !parents.length && <p>{isIssue ? 'Choose goals in the planning screen before raising an issue.' : 'Raise an issue before adding a task.'}</p>}
    {adding && <form onSubmit={add} className="roundup-add-form"><fieldset disabled={busy}>
      <label htmlFor={`${kind}-name`}>{noun} name</label><input id={`${kind}-name`} required value={name} onChange={event => setName(event.target.value)} />
      <label htmlFor={`${kind}-parent`}>{isIssue ? 'Parent Goal' : 'Parent Issue'}</label>
      <select id={`${kind}-parent`} required value={parentId} onChange={event => setParentId(event.target.value)}><option value="">Choose a parent</option>{parents.map(parent => <option key={parent._id} value={parent._id}>{parent.name}</option>)}</select>
      <button type="submit">{busy ? 'Saving…' : `Add ${noun}`}</button><button type="button" onClick={() => setAdding(false)}>Cancel</button>
    </fieldset></form>}
  </div>;
}
